import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class SpecialOrdersReferral extends UcoastEl {
	static htmlSelector = 'special-orders-referral'
	selectField: HTMLElement
	select: HTMLSelectElement
	otherField: HTMLElement
	otherInput: HTMLInputElement
	resetButton: HTMLButtonElement
	otherValue: string
	onChange: () => void
	onReset: () => void

	constructor() {
		super()
		this.selectField = q.rs('[data-uc-referral-select-field]', this)
		this.select = q.rs('[data-uc-referral-select]', this)
		this.otherField = q.rs('[data-uc-referral-other]', this)
		this.otherInput = q.rs('[data-uc-referral-other-input]', this)
		this.resetButton = q.rs('[data-uc-referral-reset]', this)
		this.otherValue = q.ra(this, 'data-other-value')
		this.onChange = () => this.updateOtherField(true)
		this.onReset = this.resetReferral.bind(this)
	}

	override connectedCallback() {
		super.connectedCallback()
		this.select.addEventListener('change', this.onChange)
		this.resetButton.addEventListener('click', this.onReset)
		this.updateOtherField()
	}

	override disconnectedCallback() {
		super.disconnectedCallback()
		this.select.removeEventListener('change', this.onChange)
		this.resetButton.removeEventListener('click', this.onReset)
	}

	updateOtherField(focusInput = false) {
		const isOther = this.select.value === this.otherValue
		this.selectField.hidden = isOther
		this.otherField.hidden = !isOther
		this.otherInput.disabled = !isOther
		this.select.setAttribute('aria-expanded', isOther.toString())
		if (!isOther) this.otherInput.value = ''
		if (isOther && focusInput) this.otherInput.focus()
	}

	resetReferral() {
		this.select.value = ''
		this.updateOtherField()
		this.select.focus()
	}
}
